export default __webpack_public_path__ + "static/SR France - Packaging food contact - Statement-f0037610cb6e1b8eb9b2d8640d402b01.pdf";